module.exports = __webpack_public_path__ + "img/logo-white.a1e58141.png";